import { FAQS } from '../../../core/constants/faq';
import { ROUTES, SECTION_IDS } from '../../../core/constants/navigation';
import { site } from '../../../global/config/site';
import Button from '../../../common/components/Button/Button';
import SectionHeading from '../../../common/components/SectionHeading/SectionHeading';
import { IconArrowRight, IconChevronDown } from '../../../common/icons';

import '../styles/faq.css';

export default function Faq() {
    return (
        <section id={SECTION_IDS.FAQ} className="faq" aria-labelledby="faq-title">
            <div className="faq__inner layout-container">
                <div className="faq__intro">
                    <SectionHeading
                        headingId="faq-title"
                        eyebrow="Preguntas frecuentes"
                        title="Resolvemos tus dudas"
                        lead={`¿No encuentras lo que buscas? Escríbenos a ${site.contactEmail} y te respondemos.`}
                    />
                    <Button to={{ pathname: ROUTES.HOME, hash: `#${SECTION_IDS.CONTACT}` }} variant="secondary" icon={<IconArrowRight />}>
                        Hablar con el equipo
                    </Button>
                </div>

                <div className="faq__list">
                    {FAQS.map((faq, index) => (
                        <details key={faq.question} className="faq__item" open={index === 0}>
                            <summary className="faq__question">
                                <h3 className="faq__question-text">{faq.question}</h3>
                                <span className="faq__toggle"><IconChevronDown /></span>
                            </summary>
                            <p className="faq__answer">{faq.answer}</p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    );
}
